var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36933",
    "data-name": "Group 36933",
    transform: "translate(9056 -12209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_3-User",
    "data-name": "Iconly/Light-Outline/3-User",
    transform: "translate(-9055.942 12208.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3-User",
    "data-name": "3-User",
    transform: "translate(1 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M10.943,10.467h.367c1.941.013,6.375.209,6.375,3.214,0,2.986-4.28,3.181-6.345,3.193h-.765c-1.941-.013-6.376-.209-6.376-3.21s4.435-3.185,6.376-3.2h.367Zm0,1.508c-2.388,0-5.236.293-5.236,1.691,0,1.365,2.678,1.685,5.017,1.7h.218c2.388,0,5.235-.292,5.235-1.687C16.177,12.272,13.331,11.975,10.943,11.975Zm7.994-1.916c2.435.365,2.947,1.509,2.947,2.4a2.207,2.207,0,0,1-1.652,2.093.762.762,0,0,1-.268.049.754.754,0,0,1-.268-1.458c.681-.259.681-.546.681-.683,0-.44-.56-.748-1.663-.913a.754.754,0,1,1,.224-1.492Zm-15.131.633a.756.756,0,0,1-.634.858c-1.1.165-1.663.472-1.663.913,0,.138,0,.423.682.683a.754.754,0,0,1-.268,1.458.762.762,0,0,1-.268-.049A2.208,2.208,0,0,1,0,12.464c0-.895.512-2.039,2.948-2.4A.759.759,0,0,1,3.806,10.693ZM10.943,0a4.592,4.592,0,0,1,0,9.185h-.027a4.578,4.578,0,0,1-4.564-4.6A4.6,4.6,0,0,1,10.943,0Zm0,1.508A3.088,3.088,0,0,0,7.859,4.592a3.07,3.07,0,0,0,3.059,3.085l.025.754V7.677a3.085,3.085,0,1,0,0-6.169ZM17.163.985a3.64,3.64,0,0,1-.085,7.2.74.74,0,0,1-.1.007.754.754,0,0,1-.1-1.5,2.132,2.132,0,0,0,.048-4.216A.754.754,0,0,1,17.163.985ZM5.588,1.606a.754.754,0,0,1-.621.866,2.132,2.132,0,0,0,.047,4.216.754.754,0,0,1-.1,1.5.74.74,0,0,1-.1-.007,3.64,3.64,0,0,1-.084-7.2A.75.75,0,0,1,5.588,1.606Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1180",
    "data-name": "Rectangle 1180",
    width: 24,
    height: 24,
    transform: "translate(-9056 12209)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3039966b4ad4763c2898128ae673da36.svg";
export { ForwardRef as ReactComponent };